import anime from 'animejs'

let duration = 500;
let easing = [.37,-0.88,.7,1.79];

export default {
  components: {
  },
  computed: {
    isMenuMainOpen:{
      get(){
        return this.$store.getters.getIsMenuMainOpen
      },
      set(val){
        this.$store.commit('setIsMenuMainOpen', val)
      }
    },
  },
  watch: {
    isMenuMainOpen(newVal, oldVal){
      if (newVal && !oldVal){
        this.animateOpen();
      }
      if (!newVal && oldVal){
        this.animateClose();
      }
    }
  },
  methods: {
    animateOpen(){
      let timelineOpen = anime.timeline({});

      timelineOpen
        .add({
          targets: this.$refs.line1,
          d: [
            {value: 'M2.308,18.571l16.263,-16.263l2.121,2.121l-16.263,16.263'}
          ],
          duration,
          easing,
        })
        .add({
          targets: this.$refs.line3,
          d: [
            {value: 'M4.429,2.308l16.263,16.263l-2.121,2.121l-16.263,-16.263'}
          ],
          duration,
          easing,
          offset: `-=${duration}`
        })
        .add({
          targets: this.$refs.line2,
          opacity: 0,
          duration,
          easing,
          offset: `-=${duration}`
        })

    },
    animateClose(){
      let timelineClose = anime.timeline({});
      timelineClose
        .add({
          targets: this.$refs.line1,
          d: [
            {value: 'M0,18l23,0l0,3l-23,0'}
          ],
          duration,
          easing,
        })
        .add({
          targets: this.$refs.line3,
          d: [
            {value: 'M0,2l23,0l0,3l-23,0'}
          ],
          duration,
          easing,
          offset: `-=${duration}`
        })
        .add({
          targets: this.$refs.line2,
          opacity: 1,
          duration,
          easing,
          offset: `-=${duration}`
        })

    }
  }
}



// WEBPACK FOOTER //
// ./src/includes/ButtonHamburger.js